/**
 * Mobile Size Check
 * @returns {Boolean} - is this device mobile sized?
 */
export default function isMobileSized() {
	return window.innerWidth < 768;
}
